import { useMutation } from '@tanstack/react-query'

import { CartViewModel, FailureEnvelop } from '@/types/api'

import { deemaTracker } from '@/components/deema/utils'

import fetchRequest from '@/app/_utils/fetch-request'

import { PostCartTypes } from '../types'

export default function usePostCartItem() {
    return useMutation<CartViewModel, FailureEnvelop['errors'], { type: PostCartTypes; productCartId: string }>({
        mutationFn: ({ type, productCartId }) =>
            fetchRequest({ method: 'POST', serviceName: 'ntl', endpoint: `/carts/_my/items/${productCartId}/${type}` }),
        onSuccess: (_, variables) => {
            variables.type === PostCartTypes.Increament && deemaTracker.setCart()
        },
    })
}
